// extracted by mini-css-extract-plugin
module.exports = {"dynamicInput":"DynamicTitleInput_dynamicInput__3n6Dw","big":"DynamicTitleInput_big__3OtOw","normal":"DynamicTitleInput_normal__1WvBj","small":"DynamicTitleInput_small__2XSz2"};